
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M23 11H13V1a1 1 0 00-1-1 1 1 0 00-1 1v10H1a1 1 0 00-1 1 1 1 0 001 1h10v10a1 1 0 001 1 1 1 0 001-1V13h10a1 1 0 001-1 1 1 0 00-1-1z"}})])
          )
        }
      }
    